import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./asset/style/app.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AiBuildingIndicator from "@/components/AiBuildingIndicator.vue";
import BottleBotWidget from "@/components/catering/BottleBotWidget.vue";
import ConvertToNewEmail from "@/components/ConvertToNewEmail.vue";
import OmniSearch from "@/components/OmniSearch.vue";
import SetupDrawer from "@/components/setup/SetupDrawer.vue";
script.components = Object.assign({}, { AiBuildingIndicator, BottleBotWidget, ConvertToNewEmail, OmniSearch, SetupDrawer }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AiBuildingIndicator, BottleBotWidget, ConvertToNewEmail, OmniSearch, SetupDrawer }, script.__o.components);}